import { createMuiTheme } from '@material-ui/core/styles';
import Theme from '../Resources/Theme';

export default createMuiTheme({
    palette: {
        primary: {
            main: '#284358',
            contrastText: Theme.Colors.White
        },
        secondary: {
            main: '#44be9b'
        },
        error: {
            main: Theme.Colors.Error
        },
        text: {
            primary: Theme.Colors.Text.primary,
            secondary: Theme.Colors.Text.secondary
        }
    },
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        h1: {
            fontSize: 52
        },
        h2: {
            fontSize: 45
        },
        h3: {
            fontSize: 36
        },
        h4: {
            fontSize: 32
        },
        h5: {
            fontSize: 28
        },
        h6: {
            fontSize: 24,
            fontWeight: 'bold'
        },
        subtitle1: {
            fontSize: 16,
            fontWeight: "bold"
        },
        subtitle2: {
            fontSize: 14,
            fontWeight: "bold"
        },
        body1: {
            fontSize: 16
        },
        body2: {
            fontSize: 14,
        },
        button: {
            fontWeight: 700
        },
        caption: {
            fontSize: 12,
            fontWeight: 'bold'
        },
        overline: {
            fontSize: 12,
            lineHeight: 1.5,
            textTransform: 'unset'
        },

    },
    overrides: {

        MuiTypography: {
            root: {
                display: 'flex',
                alignItems: 'center'
            },
        },

        MuiButton: {
            root: {

            },
            outlined: {

            },
            contained: {

            },
            disabled: {

            },
            text: {

            },

        },
        MuiInput: {

        },
        MuiInputBase: {
            input: {

            },
        },
        MuiInputLabel: {
            animated: {

            }
        },
        MuiDialog: {
            paperWidthSm: {
                maxWidth: 'unset'
            },
            container: {

            }
        },
        MuiAppBar: {
            root: {
            }
        },
        MuiChip: {
            root: {

            },
            label: {
            },
        },
        MuiFab: {
            label: {
                position: 'relative'
            },
            sizeSmall: {
                height: 36,
                width: 36
            },
            colorInherit: {
                backgroundColor: '#fff',
                color: 'black'
            }
        },
        MuiSvgIcon: {
            fontSizeSmall: {
                fontSize: '1rem'
            }
        }
    }
});